// extracted by mini-css-extract-plugin
export var button = "Carousel_button__rK3Qc";
export var ctaContainer = "Carousel_ctaContainer__3t-ek";
export var noCarouselStyle = "Carousel_noCarouselStyle__tYv7G";
export var subtitle = "Carousel_subtitle__UxYF6";
export var subtitleBold = "Carousel_subtitleBold__CS19S";
export var title = "Carousel_title__HRxGS";
export var wrapper = "Carousel_wrapper__rAj1h";